import {Route} from "../../../registry/routes.js"
import BulkTagMetadataManager from  "../../../components/files/BulkTagMetadata.vue"


const r = new Route("bulk-tagmetadata-manager", "metadata/tagbulk", {"bulk-tagmetadata-manager":BulkTagMetadataManager}, {componentType:"bin_modal_component",title:"Bulk Fields Update"}, [], true, (to, from, next)=>{document.title=`${document.title}`;next();})

export default r